import React from "react"
import PrivacyPolicyTemplate from '../../components/PrivacyPolicyTemplate/PrivacyPolicyTemplate'


const PartnersPrivacy = ({ data }) => {
    const row = {
        title: "Partners Privacy Policies",
        contents: []
    }

    return (
        <PrivacyPolicyTemplate row = { row } data = { data }/>
    )
}

export default PartnersPrivacy